import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "maint-overview" }
const _hoisted_2 = {
  key: 0,
  class: "maint-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "maint-empty"
}
const _hoisted_4 = {
  key: 2,
  class: "maint-project-grid"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "maint-card-photo" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 1,
  class: "maint-photo-empty"
}
const _hoisted_9 = { class: "maint-card-body" }
const _hoisted_10 = { class: "maint-card-name" }
const _hoisted_11 = { class: "maint-card-counts" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyServiceOrdersCard = _resolveComponent("MyServiceOrdersCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "maint-header" }, [
      _createElementVNode("h2", { class: "maint-title" }, "Manutenção"),
      _createElementVNode("p", { class: "maint-subtitle" }, "Selecione uma obra para gerenciar rotinas e Ordens de Serviço.")
    ], -1)),
    _createVNode(_component_MyServiceOrdersCard),
    (_ctx.accessLevel >= 2)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando projetos..."))
            : (_ctx.projects.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Nenhum projeto cadastrado. "))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (proj) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: proj.id,
                      class: "maint-project-card",
                      type: "button",
                      onClick: ($event: any) => (_ctx.selectProject(proj))
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        (_ctx.hasPhoto(proj.photoDataUrl))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "maint-photo-img",
                              src: _ctx.$resolveUrl(proj.photoDataUrl),
                              alt: proj.name
                            }, null, 8, _hoisted_7))
                          : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[0] || (_cache[0] = [
                              _createElementVNode("svg", {
                                width: "32",
                                height: "32",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "1.4"
                              }, [
                                _createElementVNode("rect", {
                                  x: "3",
                                  y: "3",
                                  width: "18",
                                  height: "18",
                                  rx: "3"
                                }),
                                _createElementVNode("circle", {
                                  cx: "8.5",
                                  cy: "8.5",
                                  r: "1.5"
                                }),
                                _createElementVNode("polyline", { points: "21 15 16 10 5 21" })
                              ], -1)
                            ]))])),
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "maint-card-wrench" }, [
                          _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "1.8"
                          }, [
                            _createElementVNode("path", { d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" })
                          ])
                        ], -1))
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(proj.name), 1),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.osCountFor(proj.id)) + " OS", 1)
                        ]),
                        _createElementVNode("div", {
                          class: "maint-status-badge",
                          style: _normalizeStyle(_ctx.statusStyle(proj.id))
                        }, _toDisplayString(_ctx.statusLabel(proj.id)), 5)
                      ])
                    ], 8, _hoisted_5))
                  }), 128))
                ]))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}